import { useEffect, useState } from 'react';
import Confetti from 'react-dom-confetti';
import './certificate-unlock.css';

const confettiConfig = {
  angle: 90,
  spread: 180,
  startVelocity: 45,
  elementCount: 160,
  dragFriction: 0.1,
  duration: 4500,
  stagger: 3,
  width: '14px',
  height: '14px',
  colors: ['#FFD93D', '#FF6B6B', '#6BCB77', '#4D96FF', '#FF9F45', '#C084FC'],
};

const CertificateUnlock = ({ cert, onClose, onView }) => {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setActive(true), 80);
    return () => clearTimeout(t);
  }, []);

  if (!cert) return null;

  const showBadgeImage = cert.isBadge && cert.badgeImagePath;

  return (
    <div className="mc-unlock-overlay" role="dialog" aria-labelledby="mc-unlock-title">
      <div className="mc-unlock-confetti">
        <Confetti active={active} config={confettiConfig} />
      </div>
      <div className="mc-unlock-card mc-unlock-pop">
        <div className="mc-unlock-eyebrow">&#127881; Certificate Unlocked</div>
        <div className="mc-unlock-art mc-unlock-toss">
          {showBadgeImage ? (
            <img
              src={cert.badgeImagePath}
              alt={cert.certificateName || 'Badge'}
              className="mc-unlock-badge"
            />
          ) : (
            <div className="mc-unlock-trophy">&#127942;</div>
          )}
          <div className="mc-unlock-shine" />
        </div>
        <h1 id="mc-unlock-title" className="mc-unlock-title">
          {cert.certificateName || 'Certificate of Completion'}
        </h1>
        {cert.courseName && (
          <p className="mc-unlock-course">for completing {cert.courseName}</p>
        )}
        <div className="mc-unlock-actions">
          <button className="mc-btn mc-btn-primary mc-unlock-btn-primary" onClick={onView}>
            View Certificate
          </button>
          <button className="mc-unlock-btn-ghost" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default CertificateUnlock;
